// Define types for event categories and their select options
interface EventTypeSelectOption {
  id: string
  label: string
}

interface EventCategory {
  id: string
  label: string
  eventTypeSelectOptions: EventTypeSelectOption[]
}

// Define the event statuses
export const EVENT_STATUS = {
  INACTIVE: 'inactive' as const,
  ACTIVE: 'active' as const,
}

// Define the team member event statuses
export const TEAM_MEMBER_EVENT_STATUS = {
  UNREGISTERED: 'unregistered' as const,
  REGISTERED: 'registered' as const,
}

// Define the categories with their respective options
export const tidsCategory: EventCategory = {
  id: 'tids',
  label: 'TIDS Wide Event',
  eventTypeSelectOptions: [],
}

export const happyHereCategory: EventCategory = {
  id: 'happyhere',
  label: 'Happy Here Event',
  eventTypeSelectOptions: [],
}

export const teamEventCategory: EventCategory = {
  id: 'teamEvent',
  label: 'Team Level Event',
  eventTypeSelectOptions: [
    { id: 'practice_event', label: 'Practice Event' },
    { id: 'om_event', label: 'OM Event' },
    { id: 'offsite_team_building', label: 'Offsite Team Building' },
    { id: 'recognition', label: 'Recognition' },
    { id: 'engagement_activity', label: 'Engagement Activity' },
  ],
}

export const copCategory: EventCategory = {
  id: 'cop',
  label: 'COP Event',
  eventTypeSelectOptions: [
    { id: 'brown_bag_sessions', label: 'Brown Bag Sessions' },
    { id: 'practice_community_event', label: 'Practice Community Event' },
  ],
}

// Create a type for the category select options mapping
export const categorySelectOptions: Record<string, EventCategory> = {
  TIDS: tidsCategory,
  happyhere: happyHereCategory,
  teamEvent: teamEventCategory,
  COP: copCategory,
}
